import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { DetalleSistemaUnidadSectorGrupoDTO, EtapaGrupoSeguridadDTO, SeguridadWorkflowFullDTO, SistemaSeguridadDTO, UsuarioGrupoSeguridadDTO } from './types'

const getEndpoint = (url = '') => `reportes${url}`

export const HttpReportes = {
    getDetalleSistemaUnidadSectorGrupo: (): Promise<DetalleSistemaUnidadSectorGrupoDTO[]> => {
        return HttpAxiosRequest.get(getEndpoint('/detalle-sistema-unidad-sector-grupo'))
    },

    getSeguridadWorkflowSistemasPorTipo: (codSistemaTipo: number): Promise<SistemaSeguridadDTO[]> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(
            getEndpoint('/seguridad-workflow/sistemas-por-tipo'), { codSistemaTipo }
        )
    },

    getSeguridadWorkflowEtapaGrupo: (sinCodSistema: number): Promise<EtapaGrupoSeguridadDTO[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/seguridad-workflow/${sinCodSistema}`))
    },

    getSeguridadWorkflowUsuariosPorGrupo: (idGrupo: number): Promise<UsuarioGrupoSeguridadDTO[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/seguridad-workflow/grupos/${idGrupo}/usuarios`))
    },

    getSeguridadWorkflowPdf: (
        sinCodSistema: number, nombreSistemaPrincipal: string, nombreSistemaTipo: string, vista: 'resumida' | 'detallada'
    ): Promise<any> => {
        return HttpAxiosRequest.getBlob(getEndpoint(`/seguridad-workflow/${sinCodSistema}/pdf`), {
            vchNombreSistemaPrincipal: nombreSistemaPrincipal,
            vchNombreSistemaTipo: nombreSistemaTipo,
            vista
        })
    },

    getSeguridadWorkflowCompleto: (): Promise<SeguridadWorkflowFullDTO[]> => {
        return HttpAxiosRequest.get(getEndpoint('/seguridad-workflow/completo'))
    },

    getSeguridadWorkflowCompletoPdf: (): Promise<any> => {
        return HttpAxiosRequest.getBlob(getEndpoint('/seguridad-workflow/completo/pdf'))
    }
}
